//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import common from '@/libs/common.mixin'
    import FileItem from 'c%/FileItem.vue'

    export default {
        mixins: [common],
        components: {
            FileItem
        },
        data(){
            return {
                data: {},
                content_length: 0,
                content: {},
                is_load: false
            }
        },
        mounted(){
            this.init_data()
        },
        methods: {
            init_data(){
                this.$http.get('share/my_review_detail?rs_id='+this.$route.params.id)
			    .then(res => {
			    	this.data = res.body.data

                    if(this.data.is_read==0) {
						this.doRead(this.data.rs_id)
					}

                    let count = 0
                    let content = {}
                    for(let o in this.data.review.content){
                        count += 1
                        content[o] = this.data.review.content[o]
                    }
                    for(let o in this.data.detail){
                        count += 1
                        content[o] = this.data.detail[o]
                    }
                    this.content_length = count
                    this.content = content

                    this.is_load = true
			    },res => {
			    	this.$Message.error(res.body.message)
			    })
            },
            doRead(rs_id) {
				this.$rest('share').add_url_param(rs_id,'doRead')
				.post()
				.success(res => {})
				.error(res => {})
			}
        }
    }



// WEBPACK FOOTER //
// ./src/views/public/scomment2.vue